import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import AppRoutes from './pages/AppRoutes';
import withErrorBoundary from './components/errorBoundary/withErrorBoundary';
import InternalErrorPage from './pages/error/InternalErrorPage';
import HttpError from './common/ExtendedError';
import { loginUrl, profileUrl, teamManagementUrl } from './common/config';
import messages from './messages.json';
import DeepLinkError from './common/DeepLinkError';
import { addTrackingScript, getTealiumState, isTrackingScriptInDom } from './tracking/tracking';

const baseName = process.env.PUBLIC_URL || '/';

const AppErrorBoundary = withErrorBoundary(AppRoutes, (e) => {
  if (e instanceof HttpError) {
    switch (e.response.status) {
      case 401:
        window.location.assign(loginUrl());
        return <></>;
      case 403:
        window.location.assign(profileUrl());
        return <></>;
    }
  }

  if (e instanceof DeepLinkError) {
    window.location.assign(teamManagementUrl());
    return <></>;
  }

  return <InternalErrorPage error={e} />;
});

const Root: React.FC = () => {
  useEffect(() => {
    if (!isTrackingScriptInDom()) {
      addTrackingScript();
    }
  }, []);
  useEffect(() => {
    getTealiumState(200);
  }, []);
  return (
    <IntlProvider messages={messages} locale='de' defaultLocale='de'>
      <Router basename={baseName}>
        <AppErrorBoundary />
      </Router>
    </IntlProvider>
  );
};

export default Root;
